import styled, { css } from 'styled-components';

import ActionButton from 'components/action-button';
import IconArrowLeft from 'components/icons/arrow-left';
import Picture from 'components/picture';

export const CloseButton = styled(IconArrowLeft)`
  height: 1.5rem;
  margin: 1rem 0.75rem;
  position: absolute;
  z-index: 1;
`;

const CenterAligned = css`
  align-items: center;
  display: flex;
`;

export const Header = styled.div`
  ${CenterAligned}
  font-family: ${Styles.fontFamily.brand};
  font-size: 1.125rem;
  height:3.625rem;
  margin: 0 0 2.8125rem 0;

  svg {
    margin:0 1rem 0 0;
}
`;

export const Container = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding: 0 0.75rem 1rem 0.75rem;
  width: 100%;
`;

export const ItemImage = styled(Picture)`
  margin: 0 1rem 0 0;
`;

export const MainTitle = styled.h1`
  font-family: ${Styles.fontFamily.brand};
  font-size: 2.25rem;
  margin: 0;
  max-width: 17.5rem;
`;

export const NoThanks = styled.button`
  background: transparent;
  border: 0;
  color: ${Styles.color.red};
  cursor: pointer;
  font-family: ${Styles.fontFamily.body};
  font-size: 0.9375rem;
  letter-spacing: normal;
  text-decoration: none;
  width: 100%;
`;

export const UpsizeButton = styled(ActionButton)`
  margin: 0 auto 1rem;
`;

export const UpsizeItems = styled.div`
  background-color: ${Styles.color.cardBackground};
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08), 0 2px 8px rgba(0, 0, 0, 0.07);
  border-radius: ${Styles.borderRadius};
  margin: 0 0 2.625rem 0;
  min-width: 21.25rem;
`;

export const SingleItem = styled.div`
  ${CenterAligned}
  border-bottom: solid 1px ${Styles.color.grey.four};
  cursor: pointer;
  justify-content: space-between;
  padding: 0.875rem 1.25rem 1.125rem;

  :last-of-type {
    border-bottom: 0;
  }

  span {
    border-radius: 50%;
  }
`;

export const SingleItemContent = styled.div`
  ${CenterAligned}

  h4 {
    font-family: ${Styles.fontFamily.brand};
    font-size: 1rem;
    margin: 0;
  }

  p {
    font-size: 0.8125rem;
    margin: 0;
  }
`;

export const Subtitle = styled.p`
  font-family: ${Styles.fontFamily.brand};
  font-size: 1rem;
  margin: 1rem 0.75rem;
  text-align: center;
`;
